export enum TransactionStatusesEnum {
    Pending = 1,
    Confirmed = 2,
    Declined = 3,
    Executed = 4,
}